import styled from 'styled-components';

import { colors } from 'styles/theme/colors';
import { BodySmall } from 'styles/typography';

import BenefitsByStc from './BenefitsByStc';
import { EligibilityResult, primaryCheck } from './eligibilityData';
import EligibilityOverview from './EligibilityOverview';
import SkilledNursingSection from './SkilledNursingSection';

// A completed eligibility result: a downloadable-PDF link (OLIO-2609), the subscriber+payer
// Overview, and the STC-grouped benefits table. `active` distinguishes the two success states —
// the active/inactive call itself now renders as a pill in EligibilityDetailsHeader's row
// (OLIO-3116), not as a banner here.

interface Props {
  result: EligibilityResult;
  active: boolean;
  payerLogo?: string | null;
}

export default function EligibilityResultView({ result, active, payerLogo }: Props) {
  const stedi = primaryCheck(result)?.stediResponse ?? {};
  const pdfAvailable = Boolean(result.pdf?.eligibilityCheckId);

  return (
    <>
      {/* Download PDF lives in the slideout's pinned footer now (OLIO-2794) — this result is long
          enough that a link up here was only found by scrolling back up to it. What stays here is the
          case where there ISN'T one, which belongs next to the results it's explaining. */}
      {!pdfAvailable && (
        <PdfUnavailable data-testid='eligibility-pdf-unavailable'>
          PDF download is unavailable for this benefit verification check
        </PdfUnavailable>
      )}

      <EligibilityOverview stedi={stedi} summary={result.summary} inactive={!active} payerLogo={payerLogo} />
      <SkilledNursingSection snf={result.summary?.skilledNursing} />
      <BenefitsByStc stedi={stedi} planName={stedi.subscriber?.planNumber} />
    </>
  );
}

const PdfUnavailable = styled(BodySmall)`
  color: ${colors.black50};
`;
